/**
 * @generated SignedSource<<3d85d9fd90b6db1bc1a4460d0356f458>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useChargePaymentMethod_charge$data = {
  readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly paymentMethods: ReadonlyArray<{
    readonly authorizationUrl?: string;
    readonly boletoBarcode?: string | null | undefined;
    readonly boletoDigitable?: string | null | undefined;
    readonly brCode?: string | null | undefined;
    readonly consentId?: string;
    readonly installmentNumber?: number | null | undefined;
    readonly method?: string;
    readonly status?: string | null | undefined;
    readonly value?: number | null | undefined;
    readonly valueWithDiscount?: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly type: string | null | undefined;
  readonly " $fragmentType": "useChargePaymentMethod_charge";
};
export type useChargePaymentMethod_charge$key = {
  readonly " $data"?: useChargePaymentMethod_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"useChargePaymentMethod_charge">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useChargePaymentMethod_charge"
};

(node as any).hash = "83ac32987088f0414f06182e8d1be65a";

export default node;
